// extracted by mini-css-extract-plugin
module.exports = {"svg":"components-base-Svg-Svg__svg--2nyKV"};